@if (viewModel$ | async; as viewModel) {
  @if (viewModel.products.length) {
    <div class="grid">
      @for (products of viewModel.products; track $index) {
        <mat-card appearance="outlined">
          <mat-card-content>
            <div class="grid-col-span-2 offer-name" fxLayout="row wrap">
              <mat-checkbox class="card-checkbox" appAuthorizeControl="edit||offermang" (click)="$event.stopPropagation()" fxFlex="30px"
                (change)="$event ? selection.toggle(products) : null"
                [checked]="selection.isSelected(products)">
              </mat-checkbox>
              <div class="ellipsis-3-line" fxFlex>{{ products.Detail.ProductName }}</div>
              @if (products.Rank) {
                <span class="rank">Rank : {{ products.Rank}}</span>
              }
            </div>
            <div fxLayoutAlign="center center" class="offer-image">
              <!-- <img mat-card-md-image *ngIf="products.FileName" src="{{viewModel.assetsUrl}}/{{products.FileName}}" class="product-image" alt="offer image">
              <img mat-card-md-image *ngIf="!products.FileName" src="../.././assets/images/default-image.png" class="product-image" alt="offer image"> -->
              @if (products.FacingAsset) {
                <img mat-card-md-image [src]="products.FacingAsset | offerPreview: PreviewMode.Medium" alt="Offer image" (error)="onImageError($event)">
              }
              @if (!products.FacingAsset) {
                <img mat-card-md-image src="./assets/images/default-image.png"
                  alt="Offer image" />
              }
            </div>
            <div class="offer-content" fxLayout="column">
              @if (products.ProductCategoryName) {
                <div class="offer-headline">
                  <span class="ellipsis-3-line">{{ products.ProductCategoryName}}</span>
                </div>
              }
              @if (products.ProductBrandName) {
                <div>
                  <span class="ellipsis-3-line"> {{ products.ProductBrandName }}</span>
                </div>
              }
              @if (products.Detail.Id) {
                <div>
                  <span class="ellipsis-3-line"> {{ products.Detail.Id }}</span>
                </div>
              }
              <div fxFlex fxLayout="row" fxLayoutAlign="end end">
                <a class="footer-text" [routerLink]="[products.Detail.Id]">
                  @if (isAdmin()) {
                    <span>Edit Rank</span>
                  }
                  @if (!isAdmin()) {
                    <span>View Details</span>
                  }
                </a>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>
  }
  @if (viewModel.products.length) {
    <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.page.pageSize"
      [pageSizeOptions]="[5, 10, 20, 50, 100,500]" (page)="onPage($event)"
      showFirstLastButtons [pageIndex]="viewModel.page.pageIndex">
    </mat-paginator>
  }
  @if (!viewModel.products.length) {
    <table>
      <tr>
        <td class="no-records">
          <h2>No Records Found</h2>
        </td>
      </tr>
    </table>
  }
} @else {
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
}

